import React, { Component } from "react";
import {Auth} from "aws-amplify";
import BasicButton, {ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import * as prosConnect from "../prodect/ProsConnect";
import {prosLog, prosLogErr} from "../prodect/ProsConnect";
import {Link} from "react-router-dom";
import {isValidPassWord, isValidEmail, isValidCode, PROS_PASSWORD_RULES} from "../prodect/ProsCommonUi";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import TextInput from "../components/TextInput";
import prosAppNotif from "../prodect/ProsAppNotif";

export default class AuthSignup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            email: prosConnect.getUserEmail(true) ? prosConnect.getUserEmail(true) : "",
            name: prosConnect.getUserName() ? prosConnect.getUserName() : "",
            password: "",
            confirmPassword: "",
            confirmationCode: "",
            newUser: null,
            hiliteEmail: false
        }
    }

    validateForm() {
        return (
            this.state.email &&
            isValidEmail(this.state.email, true) > 0 &&
            isValidPassWord(this.state.password) &&
            this.state.password === this.state.confirmPassword
        )
    }

    handleKeyDown =(evt)=> {
        if (evt.key === 'Enter'){
            evt.preventDefault()
            this.handleSubmit()
        }
    }

    handleChange = (id, val) => {
        this.setState({
            [id]: val
        })
    }

    async continueToConfirmCode(resendCode) {
        let ok = resendCode ? this.resendConfirmationCode() : true
        if (ok) {
            BasicModalDismiss()
            this.props.history.push("/authContinueSignonWithCode");
        }
    }

    handleSubmit = async ()=> {
        this.setState({ isLoading: true })
        try {
            let params = {
                username: this.state.email,
                password: this.state.password
            }
            const newUser = await Auth.signUp(params)
            this.setState({
                newUser
            })
        } catch (e) {
            prosLogErr('SignUp exception', e.message)
                if (e.message.indexOf("email already exists") > 0) {
                    BasicModal('Sähköpostiosoite on jo rekisteröity',
                        <>
                            <section>
                                <p>Voit tilata uuden koodin tai jatkaa, jos löysit sähköpostin jossa vahvistuskoodi.</p>
                            </section>
                            <footer className={"popup-footer"}>
                                <div className={"btn-set"}>
                                    <BasicButton
                                        btnClass={"2nd"}
                                        label={"Lähetä uusi koodi"}
                                        action={()=>{
                                            this.continueToConfirmCode(true)
                                        }}
                                    />
                                    <BasicButton
                                        btnClass={"primary"}
                                        label={"Minulla on koodi"}
                                        action={()=>{
                                            this.continueToConfirmCode(false)
                                        }}
                                    />
                                </div>
                            </footer>
                        </>,{
                            hideDismissButton: true
                    })
                }else{
                    prosAppNotif(e.message)
                }
        }
        this.setState({ isLoading: false })
    }

    handleConfirmationSubmit = async ()=> {
        this.setState({ isLoading: true })
        try {
            prosLog('Sign-up confirmation', this.state.email, this.state.confirmationCode);
            await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
            prosLog('Sign-in', this.state.email);
            await Auth.signIn(this.state.email, this.state.password);

            prosConnect.setUserEmail(this.state.email);
            this.props.userHasAuthenticated(true);
            this.props.history.push("/");
        } catch (e) {
            prosAppNotif(e.message)
            this.setState({ isLoading: false })
        }
    };

    async resendConfirmationCode() {
        this.setState({
            isLoading: true
        })
        let result
        try  {
            await Auth.resendSignUp(this.state.email)
            prosAppNotif("Vahvistuskoodi tilattu")
            result = true
        } catch (e) {
            prosLogErr('resendConfirmationCode exception', e.message)
            prosAppNotif(e.message + ". Jos olet jo rekisteröitynyt valitse 'unohdin salasanan'")
            result = false
        }
        this.setState({ isLoading: false })
        return result
    }

    renderConfirmationForm() {
        return <form onSubmit={(evt)=>{
                evt.preventDefault()
                this.handleConfirmationSubmit()
            }}>
            <TextInput
                id={"confirmationCode"}
                label={"Vahvistuskoodi"}
                autoFocus
                type={"number"}
                inputMode={"numeric"}
                value={this.state.confirmationCode}
                onChange={(val)=> this.handleChange('confirmationCode', val)}
                placeholder={"Vahvistuskoodi"}
                required
                isValid={this.state.confirmationCode.length > 5}
                onKeyDown={(evt)=>{
                    if (evt.key === 'Enter') {
                        evt.preventDefault()
                        this.handleConfirmationSubmit()
                    }
                }}
            />
            <div className={"msg"}>
                <p>Vahvistuskoodi on lähetetty sähköpostiisi.</p>
            </div>
            <Spacer size={"lg"}/>
            <div className={"btn-set_center"}>
                <BasicButton
                    btnClass={"primary"}
                    icon={isValidCode(this.state.confirmationCode) ? "check" : null}
                    label={this.state.isLoading ? "Tarkistetaan" : "Tarkista"}
                    disabled={!isValidCode(this.state.confirmationCode)}
                    loading={this.state.isLoading}
                />
            </div>
        </form>
    }


    renderPasswordFields(){
        //if email is hilited it means that I am requesting new code.
        if(this.state.hiliteEmail){
            return null
        }
        return <>
            {isValidEmail(this.state.email, true) ? <TextInput
                id={"password"}
                label={"Salasana"}
                type={"password"}
                value={this.state.password}
                onChange={(val)=> this.handleChange('password', val)}
                placeholder={"Salasana"}
                required
                isValid={isValidPassWord(this.state.password)}
                info={PROS_PASSWORD_RULES}
                onKeyDown={this.handleKeyDown}
            /> : null}
            {(isValidPassWord(this.state.password)  ?
                <TextInput
                    id={"confirmPassword"}
                    label={"Vahvista salasana"}
                    type={"password"}
                    value={this.state.confirmPassword}
                    onChange={(val)=> this.handleChange('confirmPassword', val)}
                    placeholder={"Salasana uudestaan"}
                    required
                    isValid={this.state.password === this.state.confirmPassword}
                    onKeyDown={this.handleKeyDown}
                />
                : null)}
            <div className={"btn-set_center"}>
                <ConfirmButton
                    label={this.state.isLoading ? "Rekisteröidään" : "Rekisteröi uusi tunnus"}
                    disabled={!this.validateForm()}
                    loading={this.state.isLoading}
                    action={()=> {
                        this.handleSubmit()
                    }}
                />
            </div>
        </>
    }

    renderForm() {
        let showLinks = <>
            {!this.state.hiliteEmail && <Spacer line size={"xl"}/>}
            <div className={"grid-container grid-1 grid-2_lg valign-center"}>
                {!this.state.hiliteEmail ? <div className={"text-center"}>
                    <Link
                        to="/authContinueSignonWithCode"
                        className={"lnk"}
                    >Olen saanut vahvistuskoodin</Link>
                </div> : null}
                    {this.state.hiliteEmail ? <>
                        <BasicButton
                            btnClass={"primary"}
                            label={"Lähetä vahvistuskoodi"}
                            action= {()=> {
                                if(this.state.email) {
                                    this.resendConfirmationCode()
                                }else{
                                    prosAppNotif("Kirjoita email-osoitteesi, johon koodi lahetetaan.", "notice")
                                }
                            }}
                        />
                        <div className={"text-right"}>
                            <a
                                href={"/authSignup"}
                            >Takaisin</a>
                        </div>
                    </> :
                    <div className={"text-center"}>
                        <span
                            onClick={()=>{
                                this.setState({
                                    hiliteEmail: true
                                })
                            }}
                            className={"lnk"}
                        >Lähetä uusi vahvistuskoodi</span>
                    </div>}
            </div>
        </>
        return <form
                 onSubmit={(evt)=>{
                    evt.preventDefault()
                    this.handleSubmit()
                }}
            >
            <TextInput
                hidden={this.state.hiliteEmail}
                id={"name"}
                label={"Nimi"}
                autoFocus
                value={this.state.name}
                onChange={(val)=> this.handleChange('name', val)}
                placeholder={"Kirjoita nimesi"}
                required
                isValid={this.state.name}
                isControlled
                onKeyDown={this.handleKeyDown}
            />
            <TextInput
                id={"email"}
                label={"Sähköposti"}
                type={"email"}
                value={this.state.email}
                onChange={(val)=> this.handleChange('email', val)}
                placeholder={"Sähköpostiosoitteesi"}
                required
                isValid={isValidEmail(this.state.email, true)}
                hilite={this.state.hiliteEmail && !isValidEmail(this.state.email, true)}
                onKeyDown={this.handleKeyDown}
                isControlled
            />
            {this.renderPasswordFields()}
            {showLinks}
        </form>
    }

    render() {
        return <>
            <div className="mini-page">
                <header>
                    <h1>Rekisteröi käyttäjä</h1>
                </header>
                <section>
                    {this.state.newUser === null ? this.renderForm() : this.renderConfirmationForm()}
                </section>
            </div>
        </>
    }
}
